import _ from "lodash";
import { FEEDERLISTS, ITEM } from "../_constants/actionConstants";

const initialState = {
  projItemLists: {}, // Normalized by projectId
  openBidItemDetails: {}, // Normalized by projectId, then by bidItemId
  miscSessionData: {}, // Normalized by tabId
  fetching: false,
  updating: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ITEM.FETCH_ALL:
    case ITEM.FETCH_DETAILS:
    case ITEM.FETCH_QUANTITIES_TO_DATE:
      return { ...state, fetching: true };

    case ITEM.ADD_REJECTED:
    case ITEM.FETCH_DETAILS_REJECTED:
    case ITEM.FETCH_ALL_REJECTED:
    case ITEM.FETCH_QUANTITIES_TO_DATE_REJECTED:
      return { ...state, fetching: false };

    case ITEM.ADD:
    case ITEM.EDIT:
    case ITEM.DELETE:
    case ITEM.BULK_UPDATE_DOW:
      return { ...state, updating: true };

    case ITEM.ADD_FULFILLED:
    case ITEM.EDIT_REJECTED:
    case ITEM.DELETE_FULFILLED:
    case ITEM.DELETE_REJECTED:
    case ITEM.BULK_UPDATE_DOW_FULFILLED:
    case ITEM.BULK_UPDATE_DOW_REJECTED:
      return { ...state, updating: false };

    case ITEM.FETCH_ALL_FULFILLED:
    case FEEDERLISTS.FETCH_FULFILLED: {
      const { projectId, projItemList } = action;
      if (!projectId) return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        projItemLists: {
          ...state.projItemLists,
          [projectId]: projItemList || state.projItemLists[projectId] || [],
        },
      };
    }

    case ITEM.CLEAR_DETAILS: {
      const { projectId, bidItemId } = action;
      if (
        !projectId ||
        !bidItemId ||
        !(projectId in state.openBidItemDetails) ||
        !(bidItemId in state.openBidItemDetails[projectId])
      )
        return { ...state, fetching: false };

      // Details exist, proceed to delete
      let openBidItemDetails = _.cloneDeep(state.openBidItemDetails);
      delete openBidItemDetails[projectId][bidItemId];

      return { ...state, fetching: false, openBidItemDetails };
    }

    case ITEM.EDIT_FULFILLED:
    case ITEM.FETCH_DETAILS_FULFILLED: {
      const { projectId, bidItemId, payload } = action;
      if (!projectId || !bidItemId) return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        openBidItemDetails: {
          ...state.openBidItemDetails,
          [projectId]: {
            ...state.openBidItemDetails[projectId],
            [bidItemId]: payload,
          },
        },
      };
    }

    case ITEM.FETCH_QUANTITIES_TO_DATE_FULFILLED: {
      const { tabId, payload } = action;
      if (tabId == null) return { ...state, fetching: false };

      return {
        ...state,
        miscSessionData: {
          ...state.miscSessionData,
          [tabId]: { ...state.miscSessionData[tabId], quantitiesToDate: payload },
        },
      };
    }

    default:
      return state;
  }
};
